import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import usePlayerSelector from '../../utils/usePlayerSelector';
import { store, actions } from '../../store';
import PlayerSelector from '../../components/PlayerSelector';
import TeamSelector from '../../components/TeamSelector';
import { StyledLoginPage, StyledLoginPageCard, StyledLoginForm } from './loginHelper';

const SelectAliasUser = () => {
    const { t: translate } = useTranslation();
    const [aliasTeam, setAliasTeam] = useState();
    const [aliasPlayer, setAliasPlayer] = useState();
    const { dispatch } = useContext(store);
    const { PlayerID } = usePlayerSelector();

    useEffect(() => {
        setAliasPlayer(null);
    }, [aliasTeam]);

    if (PlayerID) return <Redirect to="/" />;

    const onPlayerSelectFormSubmit = async (e) => {
        e.preventDefault();
        if (!aliasPlayer) return;

        dispatch({ type: actions.SELECT_ALIAS, data: aliasPlayer });
        dispatch({ type: actions.SET_TEAM, data: aliasTeam });
    };

    const goEnabled = aliasTeam && aliasPlayer;

    return (
        <StyledLoginPage>
            <StyledLoginPageCard>
                <StyledLoginForm onSubmit={onPlayerSelectFormSubmit}>
                    <div>
                        <Form.Group controlId="team" className="d-flex align-items-center justify-content-between">
                            <Form.Label className="mb-0">{translate('common.select-a-team')}</Form.Label>
                            <TeamSelector team={aliasTeam} onSelect={setAliasTeam} className="float-end" />
                        </Form.Group>
                        {aliasTeam && (
                            <Form.Group controlId="player" className="d-flex align-items-center justify-content-between">
                                <Form.Label className="mb-0">{translate('common.select-a-player')}</Form.Label>
                                <PlayerSelector player={aliasPlayer} onSelect={setAliasPlayer} teamid={aliasTeam?.TeamID} className="float-end" />
                            </Form.Group>
                        )}
                        <Button size="md" variant="primary" type="submit" disabled={!goEnabled}>{translate('common.go')}</Button>
                    </div>
                </StyledLoginForm>
            </StyledLoginPageCard>
        </StyledLoginPage>
    );
};

SelectAliasUser.propTypes = { };

export default SelectAliasUser;
